/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable import/no-cycle */
import React, { createContext, useEffect, useState } from 'react';
import { authStore, logoutSuccess } from '@store/slices/authSlice';
import { Modal } from 'antd';
import jwt_decode from 'jwt-decode';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import DepartmentForm from './Components/DepartmentForm';
import DepartmentList from './Components/DepartmentList';

export const DepartmentContext = createContext();
function ManageDepartment({ id }) {
  const { token } = useSelector(authStore);
  const tokenData = token && jwt_decode(token);
  const expTime = new Date(tokenData?.exp * 1000);
  const initTime = new Date(tokenData?.iat * 1000);
  const timeOut = expTime?.getTime() - initTime?.getTime();
  const dispatch = useDispatch();
  const [listDepartment, setlistDepartment] = useState({});
  const [loading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [isAddForm, setIsAddForm] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dataEmpty = [];
  const showDataDepartment = (dataDepartment) => {
    setlistDepartment(dataDepartment);
  };

  const handleOk = () => {
    dispatch(logoutSuccess());
  };

  const handleCancel = () => {
    dispatch(logoutSuccess());
  };
  const showModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    let timeoutId;

    const resetTimeout = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => setIsActive(false), timeOut);
    };

    const onActivity = () => resetTimeout();

    document.addEventListener('mousemove', onActivity);
    document.addEventListener('keydown', onActivity);

    resetTimeout();

    return () => {
      document.removeEventListener('mousemove', onActivity);
      document.removeEventListener('keydown', onActivity);
      clearTimeout(timeoutId);
    };
  }, []);
  return (
    <>
      <div>
        <Modal
          className="modal-timeout"
          okText="はい"
          open={!isActive}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <p className="text-center">タイムアウトしました。</p>
          <p className="text-center">再度ログインしてください。</p>
        </Modal>
      </div>

      <DepartmentContext.Provider
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value={{ listDepartment, showDataDepartment, loading, setLoading }}
      >
        <div className="display-flex flex-column full-height color-page">
          <Modal
            title={isAddForm ? '部署追加' : '部署変更'}
            open={isModalOpen}
            onCancel={closeModal}
            className="modal-add modal-singer"
            footer={null}
          >
            <DepartmentForm
              closeModal={closeModal}
              isAddForm={isAddForm}
              showModal={showModal}
              initialValues={isAddForm ? dataEmpty : listDepartment}
              idCompany={id}
            />
          </Modal>
          <DepartmentList
            showModal={showModal}
            setIsAddForm={setIsAddForm}
            company_id={id}
          />
        </div>
      </DepartmentContext.Provider>
    </>
  );
}

ManageDepartment.propTypes = {
  id: PropTypes.number,
};

export default ManageDepartment;
